package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.AuthResponse
import com.arena_web.utils.MetaPixel
import com.arena_web.utils.Storage
import com.arena_web.utils.TikTokPixel
import com.arena_web.utils.StorageKeys

// Registration conversion (Meta CompleteRegistration) is now fired server-side
// via the Conversions API — see the backend AuthRoute. The browser pixel only
// fires PageView (from the <head> base snippet) and other conversions.
fun saveAuthSession(response: AuthResponse) {
    Storage.save(StorageKeys.ACCESS_TOKEN, response.accessToken)
    Storage.save(StorageKeys.REFRESH_TOKEN, response.refreshToken)
    Storage.save(StorageKeys.USER_ID, response.user.id)
    Storage.save(StorageKeys.USER_EMAIL, response.user.email)
    Storage.save(StorageKeys.USERNAME, response.user.username)
    response.user.fullName?.let { Storage.save(StorageKeys.FULL_NAME, it) }
    response.user.avatarUrl?.let { Storage.save(StorageKeys.AVATAR_URL, it) }
    // Feed the now-known identity into the pixels for Advanced Matching.
    MetaPixel.setAdvancedMatching(response.user.email, response.user.id)
    TikTokPixel.identify(response.user.email, response.user.id)
}
